"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TfaChannelEnum = void 0;
var TfaChannelEnum;
(function (TfaChannelEnum) {
    TfaChannelEnum["AUTH_APP"] = "AUTH_APP";
    TfaChannelEnum["SMS"] = "SMS";
})(TfaChannelEnum || (exports.TfaChannelEnum = TfaChannelEnum = {}));
